import { render, staticRenderFns } from "./NavbarSelector.vue?vue&type=template&id=44655f20&scoped=true&"
import script from "./NavbarSelector.vue?vue&type=script&lang=js&"
export * from "./NavbarSelector.vue?vue&type=script&lang=js&"
import style0 from "./NavbarSelector.vue?vue&type=style&index=0&id=44655f20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44655f20",
  null
  
)

export default component.exports